module.exports = __webpack_public_path__ + "img/汇总统计.b05514dc.png";